import React, { useEffect, useRef } from 'react';
import './ComoFunciona.css';
import '../../shared/ui/modal-close-button.css'; // X padrão do sistema

export interface ComoFuncionaSecao {
  titulo: string;
  conteudo: React.ReactNode;
}

interface ComoFuncionaProps {
  isOpen: boolean;
  onClose: () => void;
  titulo: string;
  secoes: ComoFuncionaSecao[];
}

const ComoFunciona: React.FC<ComoFuncionaProps> = ({ isOpen, onClose, titulo, secoes }) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isOpen && drawerRef.current && !drawerRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    // at-72: fechar com Esc. Registrado e removido em simetria com o `mousedown` acima.
    //
    // ATENÇÃO para quem for dar `Escape`-close a um modal que HOSPEDA este drawer: os dois
    // listeners ficam em `document`, logo são irmãos — `stopPropagation` não separa um do
    // outro. A defesa é guarda por estado, como o `ChecklistModal` já faz para o clique fora
    // (`if (confirmModal.isOpen || isHelpOpen) return;`).
    const handleKeyDown = (event: KeyboardEvent) => {
      if (isOpen && event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="como-funciona-overlay">
      <div className="como-funciona-drawer" ref={drawerRef}>
        <div className="como-funciona-header">
          <h2>{titulo}</h2>
          <button className="close-button" onClick={onClose} aria-label="Fechar ajuda">
            &times;
          </button>
        </div>
        <div className="como-funciona-body">
          {secoes.map((secao, idx) => (
            <div key={idx} className="como-funciona-section">
              <h3>{secao.titulo}</h3>
              <div className="como-funciona-content">{secao.conteudo}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComoFunciona;
